// Right-hand panel for a selected military unit (strategy-game style).

import { unitSymbolSvg } from '../utils/military'

const Bar = ({ label, value }) => {
  const v = Math.max(0, Math.min(100, Number(value) || 0))
  const color = v < 25 ? '#e07070' : v < 60 ? '#e0b050' : '#7dc97d'
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr 42px', gap: 8, alignItems: 'center', fontSize: 13, marginBottom: 4 }}>
      <span>{label}</span>
      <div style={{ background: 'rgba(0,0,0,.4)', borderRadius: 999, height: 8, overflow: 'hidden' }}>
        <div style={{ width: `${v}%`, height: '100%', background: color, borderRadius: 999 }} />
      </div>
      <span style={{ textAlign: 'right', opacity: .8 }}>{v.toFixed(0)}%</span>
    </div>
  )
}

const UnitPanel = ({ unit, onClose }) => {
  if (!unit) return null
  const st = unit.status || {}
  return (
    <div
      style={{
        position: 'absolute', top: 60, right: 10, zIndex: 30,
        width: 320, maxHeight: 'calc(100vh - 90px)', overflowY: 'auto',
        background: 'rgba(14,14,14,.95)', color: '#f0f0f0',
        border: '1px solid #2a2a2a', borderRadius: 12, padding: 16,
        boxShadow: '0 8px 24px rgba(0,0,0,.5)',
      }}
    >
      <button
        onClick={onClose}
        style={{ float: 'right', background: 'none', border: 'none', color: '#808080', cursor: 'pointer', fontSize: 16 }}
        title="Fermer"
      >✕</button>
      <h3 style={{ margin: '0 0 2px', color: '#D5B654' }}>{unit.name}</h3>
      <p style={{ margin: 0, fontSize: 12, color: '#808080' }}>
        {unit.echelon?.name || 'Échelon inconnu'}
        {unit.commander_name ? ` · 👤 ${unit.commander_name}` : ''}
      </p>
      <div
        style={{ textAlign: 'center', margin: '10px 0' }}
        dangerouslySetInnerHTML={{ __html: unitSymbolSvg(unit, 60) }}
      />
      <div style={{ borderTop: '1px solid #2a2a2a', paddingTop: 10 }}>
        <Bar label="Prêt au combat" value={st.readiness} />
        <Bar label="Moral" value={st.morale} />
        <Bar label="Entraînement" value={st.training} />
        <Bar label="Expérience" value={st.experience} />
        <Bar label="Carburant" value={st.fuel_level} />
        <Bar label="Ravitaillement" value={st.supply_level} />
      </div>
      <div style={{ borderTop: '1px solid #2a2a2a', marginTop: 10, paddingTop: 10, fontSize: 13 }}>
        <div>Effectifs : <strong>{(st.current_manpower ?? 0).toLocaleString('fr-FR')}</strong></div>
        {unit.position && (
          <div style={{ color: '#808080', marginTop: 4 }}>
            📍 {unit.position.lat.toFixed(3)}, {unit.position.lon.toFixed(3)}
          </div>
        )}
      </div>
      <div style={{ marginTop: 12 }}>
        <a
          href="https://play.projet-resurgence.fr/militaire/orbat"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#D5B654', fontSize: 13 }}
        >
          Gérer dans le Commandement Militaire ↗
        </a>
      </div>
    </div>
  )
}

export default UnitPanel
